import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { MessageScreen } from "../../common/MessageScreen";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

@inject("externalInterfaceStore")
export class CardTanSettingsPinSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                title={ui.__("cardTanSettings.pin.success.title")}
                messageComponent={<i18n.FormattedHTMLMessage id="cardTanSettings.pin.success.message" />}
                buttonLabelId="common.close"
                onDismiss={() => pushRoute(CardTanSettingsRoutes.ROOT)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsPinSuccess.tsx